module.exports = __webpack_public_path__ + "static/media/req-workspace-seller-lawyer-help2.db1e2c12.svg";